import React from "react";

import SalesComponent from "../components/Sales/SalesComponent";

const SalesPage = () => {
	
	return <SalesComponent/>;
};

export default SalesPage